export type LanguageOption = {
    label: string;
    value: string;
};

/**
 * The languages a user or a form can be set to. Labels are written in the language they name,
 * so they stay readable to a speaker of that language and are never translated.
 */
export const languageOptions: LanguageOption[] = [
    {
        label: 'English (UK)',
        value: 'en_GB',
    },
    {
        label: 'English (US)',
        value: 'en_US',
    },
    {
        label: 'Deutsch',
        value: 'de_DE',
    },
    {
        label: 'Schwizerdütsch',
        value: 'de_CH',
    },
    {
        label: 'Dansk',
        value: 'da_DK',
    },
    {
        label: 'Norsk',
        value: 'no_NO',
    },
    {
        label: 'Español',
        value: 'es_ES',
    },
    {
        label: 'Español (Latinoamérica)',
        value: 'es_US',
    },
    {
        label: 'Nederlands',
        value: 'nl_NL',
    },
];
